import React, { Component } from 'react'
import '../../../assets/css/pages/Subscription.css'
import { TiTick } from "react-icons/ti";


export default class Subscription extends Component {
    render() {
        return (
            <>
                <div className="page-content">
                    <div className="container-fluid">
                        <h4 className="mb-0 font-size-18">Subscription</h4>
                        <div className="row">
                            <div className="col-md-3">
                                <div className='subscription_card'>
                                    <div className='text-center'>
                                        <h4>Standard</h4>
                                        <h1>$800</h1>
                                        <h6>/user/month billed annually</h6>
                                        <div className='mt-3'>
                                            <p className='subs_status'>Downgrade</p>
                                        </div>
                                    </div>
                                    <div className='mt-4'>
                                        <h5>All the essentials:</h5>
                                        <p><span><TiTick size={20} className='mb-1'/></span>20 Test</p>
                                        <p><span><TiTick size={20} className='mb-1'/></span>05 Report Generate</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className='subscription_card'>
                                    <div className='text-center'>
                                        <h4>Professional</h4>
                                        <h1>$1400</h1>
                                        <h6>/user/month billed annually</h6>
                                        <div className='mt-3'>
                                            <p className='subs_status'>Downgrade</p>
                                        </div>
                                    </div>
                                    <div className='mt-4'>
                                        <h5>All the essentials:</h5>
                                        <p><span><TiTick size={20} className='mb-1'/></span>60 Test</p>
                                        <p><span><TiTick size={20} className='mb-1'/></span>10 Report Generate</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className='subscription_card2 '>
                                    <div className='text-center'>
                                        <h4>Enterprise</h4>
                                        <h1>$2400</h1>
                                        <h6>/user/month billed annually</h6>
                                        <div className='mt-3'>
                                            <p className='subs_status2'>Active</p>
                                        </div>
                                    </div>
                                    <div className='mt-4'>
                                        <h5>All the essentials:</h5>
                                        <p><span><TiTick size={20} className='mb-1'/></span>100 Test</p>
                                        <p><span><TiTick size={20} className='mb-1'/></span>30 Report Generate</p>
                                        <p><span><TiTick size={20} className='mb-1'/></span>Mass email</p>

                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className='subscription_card'>
                                    <div className='text-center'>
                                        <h4>Ultimate</h4>
                                        <h1>$2600</h1>
                                        <h6>/user/month billed annually</h6>
                                        <div className='mt-3'>
                                            <p className='subs_status'>Upgrade</p>
                                        </div>
                                    </div>
                                    <div className='mt-4'>
                                        <h5>All the essentials:</h5>
                                        <p><span><TiTick size={20} className='mb-1'/></span> 120 Test</p>
                                        <p><span><TiTick size={20} className='mb-1'/></span>50 Report Generate</p>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
